const featureItems = [
  {
    icon: 'ri-shield-check-line',
    title: '匿名爆料保护',
    desc: '端到端加密传输，严格保护每一位爆料人的身份信息，让真话不再需要勇气。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '凌晨准时更新',
    desc: '每日凌晨 3:00 自动刷新传送门，确保你不会错过任何一条最新内幕与猛料。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '深度调查追踪',
    desc: '不满足于表面信息，每条爆料均经过多方交叉验证，提供事件完整时间线。',
  },
  {
    icon: 'ri-fire-line',
    title: '全网热度聚合',
    desc: '实时监测微博、抖音、小红书等平台话题热度，第一时间捕捉舆论风暴中心。',
  },
  {
    icon: 'ri-chat-smile-2-line',
    title: '去水军真评论',
    desc: '严格过滤机器人与水军评论，仅展示真实用户反馈，呈现最原生态的瓜友观点。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950">
            ⭐ 核心优势
          </h2>
          <span className="text-sm text-foreground-500">
            为什么千万吃瓜群众选择黑料视频
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featureItems.slice(0, 2).map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-6 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="w-11 h-11 rounded-xl bg-background-950 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-xl text-primary-400 w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}

          <div className="bg-background-50 rounded-xl p-6 border border-background-200/60 border-l-[3px] border-l-primary-500 hover:border-primary-200 transition-colors cursor-pointer md:row-span-2 flex flex-col justify-center">
            <div className="w-14 h-14 rounded-xl bg-primary-100 flex items-center justify-center mb-5">
              <i className={`${featureItems[2].icon} text-2xl text-primary-600 w-6 h-6 flex items-center justify-center`}></i>
            </div>
            <h3 className="text-xl font-bold text-foreground-900 mb-3">{featureItems[2].title}</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">{featureItems[2].desc}</p>
          </div>

          {featureItems.slice(3).map((item, idx) => (
            <div
              key={idx + 3}
              className="bg-background-50 rounded-xl p-6 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="w-11 h-11 rounded-xl bg-background-950 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-xl text-primary-400 w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}